<template>
  <el-row>
    <el-col :span="24">
      <h3 class="form-title">Reconciliation of National Presentation with GFS</h3>
    </el-col>
    <el-col :span="24">
      <div v-loading="loading" class="fs-section-card">
        <template v-if="!loading">
          <div v-if="reconciliation" class="fs-file-row">
            <div class="fs-file-info">
              <span class="fs-file-name">{{ reconciliation.file_name }}</span>
              <el-tag size="small" type="info">.{{ reconciliation.file_extension }}</el-tag>
            </div>
            <div class="fs-file-actions">
              <el-button type="primary" @click="downloadFile(reconciliation)">
                Yuklab olish
              </el-button>
              <input
                type="file"
                ref="fileInputRef"
                hidden
                accept=".xlsx,.xls"
                @change="uploadAndSave"
              />
              <el-button :loading="saving" @click="fileInputRef.click()">
                Almashtirish
              </el-button>
            </div>
          </div>
          <div v-else class="fs-empty-row">
            <span class="fs-empty-text">Fayl yuklanmagan</span>
            <input
              type="file"
              ref="fileInputRef"
              hidden
              accept=".xlsx,.xls"
              @change="uploadAndSave"
            />
            <el-button
              type="primary"
              :loading="saving"
              @click="fileInputRef.click()"
            >
              Fayl yuklash
            </el-button>
          </div>
        </template>
      </div>
    </el-col>
  </el-row>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import http from "@/http";
import store from "@/store";

const loading = ref(false);
const saving = ref(false);
const reconciliation = ref(null);
const fileInputRef = ref();

const FILE_URL = process.env.VUE_APP_BASE_API_URL + "api/v2/info/file/";

const fetchReconciliation = () => {
  loading.value = true;
  http
    .get("api/v1/financial-statistic-gfs-reconciliation")
    .then(({ data }) => {
      reconciliation.value = data;
    })
    .catch(({ response }) => {
      if (response?.status !== 404) {
        ElMessage.error("Ma'lumot olishda xatolik");
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

const downloadFile = (file) => {
  const link = document.createElement("a");
  link.href = FILE_URL + file.file_id;
  link.setAttribute("download", file.file_name || file.file_id);
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const uploadAndSave = (event) => {
  const file = event.target.files[0];
  if (!file) return;
  if (file.size / 1024 / 1024 > 20) {
    ElMessage.error("Fayl xajmi max. 20MB bo'lishi kerak!");
    event.target.value = "";
    return;
  }
  const formData = new FormData();
  formData.append("file", file);
  saving.value = true;
  http
    .post(`${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`, formData, {
      headers: {
        Authorization: store.state.accessToken,
        "Content-Type": "multipart/form-data",
      },
    })
    .then(({ data }) => {
      return http({
        url: "api/v1/financial-statistic-gfs-reconciliation",
        method: "put",
        data: { file_id: data.hashId },
      });
    })
    .then(({ data }) => {
      reconciliation.value = data;
      ElMessage.success("Muvaffaqqiyatli saqlandi");
    })
    .catch(() => {
      ElMessage.error("Saqlashda xatolik. Qayta urinib ko'ring!");
    })
    .finally(() => {
      saving.value = false;
      event.target.value = "";
    });
};

onMounted(fetchReconciliation);
</script>

<style scoped lang="scss">
.fs-section-card {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 24px;
  min-height: 100px;
}

.fs-file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}

.fs-file-info {
  display: flex;
  align-items: center;
  gap: 8px;
}

.fs-file-name {
  font-size: 14px;
  font-weight: 500;
  color: #303133;
}

.fs-file-actions {
  display: flex;
  gap: 8px;
}

.fs-empty-row {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #909399;
}

.fs-empty-text {
  font-size: 14px;
}
</style>
